import type { ComponentEntry } from '../../core/common-types'

const entry: ComponentEntry = {
	componentType: 'FontFaces',
	loadComponent: () => import('./FontFaces.js' /* webpackChunkName: "FontFaces" */),
}

export default entry
